import React from 'react';

import { Button, TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './ChangePasswordRow.module.scss';

type ChangePasswordRowProps = {
  onPasswordChange: () => void;
};

const ChangePasswordRow = ({ onPasswordChange }: ChangePasswordRowProps) => {
  return (
    <div className={classes.row}>
      <TitleWithDescription
        title="Generate a new password and send it using various methods."
        description="Instead of the user, you can generate a new password and provide it to them. Then user will use this password during the login process."
        titleFont="body-14-bold"
        className={classes.title}
      />
      <Button variant="outlined" size="small" onClick={onPasswordChange}>
        Change Password
      </Button>
    </div>
  );
};

export { ChangePasswordRow };
